import { render, staticRenderFns } from "./downstreamInvoiceEdit.vue?vue&type=template&id=29980245&scoped=true"
import script from "./downstreamInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./downstreamInvoiceEdit.vue?vue&type=script&lang=js"
import style0 from "./downstreamInvoiceEdit.vue?vue&type=style&index=0&id=29980245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29980245",
  null
  
)

export default component.exports